module.exports = __webpack_public_path__ + "img/position.745a87ff.png";